<template>
    <div class="card card-with-table">
        <div class="card-body">
            <table class="table table-striped table-hover table-vm-list">
                <thead>
                    <tr>
                        <th v-sort:id class="d-none d-lg-table-cell">Номер</th>
                        <th class="pl-3 d-table-cell d-lg-none text-nowrap">
                            <span v-sort:id>Номер</span><span class="px-3">/</span><span v-sort:name>Название</span>
                        </th>

                        <th class="d-none d-lg-table-cell">Статус</th>
                        <th v-sort:name class="d-none d-lg-table-cell">Название</th>
                        <th v-feature="'loading'" class="pr-3 d-table-cell d-md-none">Загрузка</th>
                        <th v-sort:vends_sum class="d-none d-xl-table-cell">Доход</th>
                        <th v-sort:vends_count class="d-none d-xl-table-cell">Продажи</th>
                        <th v-sort:products_loading v-feature="'loading'" class="d-none d-md-table-cell text-nowrap"><i class="tlm-icon-spiral text-primary" /></th>
                        <th v-sort:recipes_loading v-feature="'loading'" class="d-none d-md-table-cell text-nowrap"><i class="tlm-icon-coffee-togo text-primary" /></th>
                        <th v-if="extended && hasCrt" class="d-none d-xl-table-cell">Чеки</th>
                        <th v-if="extended" class="d-none d-md-table-cell" />
                    </tr>
                </thead>

                <tbody v-if="!noOne && vms.length !== 0">
                    <tr v-for="vm in vms" :key="vm.id">
                        <td class="d-none d-lg-table-cell">T{{ vm.id }}</td>

                        <td class="pl-3 d-table-cell d-lg-none vm-state-mobile truncate">
                            <div :class="{ 'bg-warning': vm.state === null, 'bg-success': vm.state === 1, 'bg-danger': vm.state === 0 }" />
                            T{{ vm.id }} / <router-link :to="{ name: 'vm', params: { id: vm.id }}">{{ vm.name }}</router-link>
                        </td>

                        <td class="d-none d-lg-table-cell">
                            <vm-state-badge :vm="vm" />
                        </td>

                        <td class="d-none d-lg-table-cell truncate">
                            <router-link :to="{ name: 'vm', params: { id: vm.id }}">{{ vm.name }}</router-link>
                        </td>

                        <td v-feature="'loading'" class="pr-3 d-table-cell d-md-none">
                            <vm-loading-level :loading="vm.loading ? (vm.loading.recipes.loading + vm.loading.products.loading) : 0" :max="vm.loading ? (vm.loading.recipes.max + vm.loading.products.max) : 0" type="components" />
                        </td>

                        <td class="d-none d-xl-table-cell font-weight-bold">{{ (vm.vends && vm.vends.sum || 0) | money }}</td>
                        <td class="d-none d-xl-table-cell font-weight-bold">{{ vm.vends && vm.vends.count || '–' }}</td>

                        <td v-feature="'loading'" class="d-none d-md-table-cell">
                            <span v-if="vm.loading && vm.loading.products.loading !== null">{{ vm.loading.products.loading }}/{{ vm.loading.products.max }}</span>
                            <span v-else class="text-muted">–</span>
                        </td>

                        <td v-feature="'loading'" class="d-none d-md-table-cell">
                            <vm-loading-level v-if="vm.loading && vm.loading.recipes.loading !== null" :loading="vm.loading.recipes.loading" :max="vm.loading.recipes.max" type="components" />
                            <span v-else class="text-muted">–</span>
                        </td>

                        <td v-if="extended && hasCrt" class="d-none d-xl-table-cell">
                            <i v-if="vm.is_crt_active" class="tlm-icon-check small text-primary" title="Чеки отправляются" />
                        </td>

                        <td v-if="extended && remove" class="action-buttons d-none d-md-table-cell">
                            <button type="button" class="btn btn-icon btn-remove" @click="deleteVm(vm.id)" />
                        </td>
                    </tr>
                </tbody>

                <tfoot v-if="noOne && !isInfinite" class="no-one">
                    <tr>
                        <td colspan="42">Вы пока не добавили ни одного торгового автомата.</td>
                    </tr>
                </tfoot>

                <tfoot v-if="meta.last_page > 1 && !isInfinite">
                    <tr>
                        <td colspan="42">
                            <pagination :meta="meta" @input="applyFilter({ page: $event })" />
                        </td>
                    </tr>
                </tfoot>

                <tfoot class="infinite" v-if="isInfinite">
                    <tr>
                        <td colspan="42">
                            <slot name="moar" />
                        </td>
                    </tr>
                </tfoot>
            </table>
        </div>
    </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import VmLoadingLevel from '@/components/VmLoadingLevel'
import VmStateBadge from '@/components/VmStateBadge'
import axios from 'axios'
import router from '@/router'
import { toastSuccess, toastError, confirm } from '@/dialogs'
import FileSaver from 'file-saver'

export const getFile = async (format) => {
    let response = await axios.get('api/vms/file', {
        responseType: 'blob',
        params: { ...router.currentRoute.query, format: format }
    })

    if (!response.data.size) {
        return
    }

    let blob = new Blob([response.data], { type: format === 'xlsx' ? 'application/vnd.ms-excel' : 'text/csv' })
    FileSaver.saveAs(blob, 'торговые автоматы.' + format)
}

export default {
    components: {
        Pagination,
        VmLoadingLevel,
        VmStateBadge
    },

    props: {
        extended: {
            type: Boolean,
            default: false
        },

        vms: {
            type: Array,
            default: _ => []
        },

        meta: {
            type: Object,
            default: _ => ({})
        },

        hasCrt: {
            type: Boolean,
            default: false
        },

        hasLoading: {
            type: Boolean,
            default: false
        },

        remove: {
            type: Boolean,
            default: false
        },

        isInfinite: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        noOne() {
            return this.meta.current_page === 1 && this.vms.length === 0;
        }
    },

    methods: {
        async deleteVm(vmId) {
            const isConfirm = await confirm('Вы уверены, что хотите удалить?')

            if (isConfirm) {
                let done = await this.$store.dispatch('vms/delete', vmId)
                done ? toastSuccess('Удалено') : toastError('Ошибка')
            }
        }
    }
}
</script>

<style lang="scss">
@import "../scss/_variables";

.table-vm-list {
    i {
        font-size: 1rem;
        color: $blue;
    }

    thead {
        th {
            line-height: 1rem;
            vertical-align: middle;

            &:nth-child(4) {
                min-width: 200px;
                width: 100%;
            }

            &:nth-child(6) {
                width: 150px;
            }

            &:nth-child(10), &:nth-child(11) {
                width: 50px;
            }
        }
    }

    tbody {
        tr {
            td {
                vertical-align: middle;
            }
        }
    }
}

</style>
